export default "__VITE_ASSET__0440b483__"